var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarkMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "9 12 12 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n        stroke: #ffffff;\n        fill: #ffffff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_1",
    "data-name": 1,
    className: "cls-1",
    d: "M20.137,13.854a1.077,1.077,0,0,0-1.439,0l-3.664,3.354-3.612-3.354a1.077,1.077,0,0,0-1.439,0,0.9,0.9,0,0,0-.006,1.34L9.983,15.2l4.327,4.017a1.077,1.077,0,0,0,1.443.006l0.006-.006L20.137,15.2a0.9,0.9,0,0,0,.006-1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkMini);
export default __webpack_public_path__ + "static/media/mark-mini.77797d1ad01f29c5d32fadb8c978c0dc.svg";
export { ForwardRef as ReactComponent };